

























































































































































































































import { Component, Emit, Prop, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { findIndex, orderBy } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { Alert, ReserveCollection, SystemCode } from '@/api'
import {
  AlertCodeAL300050,
  BibliographyDetailRealTabType,
  BibliographyDetailSetTabType,
  CollectionFlag,
  Prefix,
  ReserveStatus,
  ReserveType,
  SearchType,
  SortOrder
} from '@/types'
import { PAGE_LEND_RESET } from '@/config/event'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'
import dayjs from 'dayjs'
import { AlertFactory } from '@/factory'
import { alertStore } from '@/utils/store-accessor'

export interface ReservedCollectionsTableItem extends ReserveCollection {
  isSelected: boolean
}

const COLS: Col[] = [
  {
    width: 26,
    items: [
      {
        name: 'check',
        align: 'center'
      }
    ]
  },
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayClass',
        headerText: '分類番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '11',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reserveRegistrationTime',
        headerText: '予約/処理日',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '12',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reserveExpiration',
        headerText: '受取待期限日',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reserveRegistrationBranchCode',
        headerText: '予約館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '8',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'forwardingBranchCode',
        headerText: '回送館',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '7',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'specifyCollectionId',
        headerText: '種別',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '9',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayMaterialFormat',
        headerText: '資料形態',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '11',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'bibliographyCollectionId',
        headerText: '書誌資料番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reserveStatusMessage',
        headerText: 'メッセージ',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '6',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayMemo',
        headerText: 'メモ',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 70,
    resizable: true,
    movable: true,
    items: [
      {
        name: 'detail',
        align: 'center',
        headerText: ''
      }
    ]
  },
  {
    width: 30,
    resizable: true,
    movable: true,
    items: [
      {
        name: 'remove',
        align: 'center',
        headerText: ''
      }
    ]
  }
]

@Component({
  components: {
    IconBibliography,
    DataTable
  }
})
export default class ReservedCollectionsTable extends ComponentVue {
  @Prop({
    type: Array
  })
  items!: (ReserveCollection | ReservedCollectionsTableItem)[]

  @Prop({
    type: Boolean
  })
  isAllSelect!: boolean

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  edit!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  isCheckBox!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  dialog!: boolean

  @Prop({
    type: Boolean,
    default: true
  })
  isTitleLink!: boolean

  @Prop({
    type: String,
    default: ''
  })
  userId!: string

  @Prop({
    type: Boolean,
    default: false
  })
  specifyCollectionIdLink!: boolean

  sortName: string = ''

  sortOrder: SortOrder = ''

  get reserveType(): any {
    return ReserveType
  }

  get allCols(): Col[] {
    return COLS
  }

  get cols(): Col[] {
    let cols = [...this.allCols]

    if (!this.edit) {
      cols = cols.filter(
        item =>
          item.items[0].name !== 'remove' && item.items[0].name !== 'detail'
      )
    }

    if (!this.isCheckBox) {
      cols = cols.filter(item => item.items[0].name !== 'check')
    }

    return cols
  }

  get sortedItems(): ReserveCollection[] {
    if (this.sortName) {
      return orderBy<ReserveCollection>(
        this.items,
        (item: ReserveCollection) => {
          if (this.sortName === 'displayTitle') {
            return item.displayTitle + item.displayAuthor
          }

          if (this.sortName === 'bibliographyCollectionId') {
            return this.bibliographyCollectionId(
              item.prefix,
              item.bibliographyId,
              item.collectionNo
            )
          }

          const propertyValue = item[this.sortName as keyof ReserveCollection]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  bibliographyCollectionId(
    prefix: Prefix,
    bibliographyId: number,
    collectionNo: string
  ): string {
    if (collectionNo === '') {
      return `${prefix}${String(bibliographyId).padStart(10, '0')}`
    }

    return collectionNo
  }

  @Watch('dialog')
  initializeSort(): void {
    if (this.dialog) return

    this.onSort({
      name: '',
      order: ''
    })
  }

  activated() {
    this.$eventBus.on(PAGE_LEND_RESET, this.initializeDataProperty)
  }

  deactivated() {
    this.$eventBus.off(PAGE_LEND_RESET)
  }

  chipColor(item: ReserveCollection | ReservedCollectionsTableItem): string {
    switch (item.reserveStatusMessage) {
      case '受取待':
        if (
          item.reserveExpiration !== '' &&
          this.isCurrentDateThanBefore(item.reserveExpiration)
        ) {
          return 'red'
        } else {
          return 'yellow accent-4'
        }
      case '準備中':
        return '#99D9EA'
      case '回送中':
        return 'orange'
      default:
        return ''
    }
  }

  isSearchTypeMagazine(code: string): boolean {
    return code === SearchType.Magazine
  }

  isReserveStatusReturnWaiting(reserveStatus: SystemCode): boolean {
    return reserveStatus.code === ReserveStatus.ReturnWaiting
  }

  existsDisplayMemo(memo: string | null): boolean {
    return !!memo
  }

  initializeDataProperty(): void {
    this.sortName = ''
    this.sortOrder = ''
  }

  isCurrentDateThanBefore(date: string): boolean {
    return date < dayjs().format('YYYYMMDD')
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onClickRow(index: number) {
    if (!this.isCheckBox) return

    const targetIndex: number = this.items.findIndex(
      value => value.id === this.sortedItems[index].id
    )

    if (~targetIndex) {
      // eslint-disable-next-line standard/computed-property-even-spacing
      ;(this.items[
        targetIndex
        // eslint-disable-next-line standard/computed-property-even-spacing
      ] as ReservedCollectionsTableItem).isSelected = !(this.items[
        targetIndex
      ] as ReservedCollectionsTableItem).isSelected
    }
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }

  onClickDeleteReserveExpiration(index: number): void {
    const alert: Alert = AlertFactory.create(AlertCodeAL300050)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.$emit(
          'delete:reserve-expiration',
          findIndex(this.items, {
            id: this.sortedItems[index].id
          })
        )
      }
    })
  }

  // ここから資料照会ダイアログ
  openModalBibliographyDetail(
    prefix: Prefix,
    bibliographyId: number,
    bibliographyContentId?: number
  ) {
    if (prefix === Prefix.Set) {
      this.openModalBibliographyDetailSet(
        bibliographyId,
        BibliographyDetailSetTabType.Volume
      )
      return
    }
    this.openModalBibliographyDetailReal(
      bibliographyId,
      BibliographyDetailRealTabType.Reserve,
      bibliographyContentId
    )
  }

  openModalBibliographyDetailReal(
    bibliographyRealId: number,
    tabType: BibliographyDetailRealTabType,
    bibliographyContentId?: number
  ) {
    this.$modalBibliographyDetailReal.open({
      bibliographyRealId,
      isBibliographySelectProcess: false,
      tabType,
      bibliographyContentId,
      userId: this.userId,
      onToggleSet: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailSet(bibliographyId, tabType)
      }
    })
  }

  openModalBibliographyDetailSet(
    bibliographySetId: number,
    tabType: BibliographyDetailSetTabType
  ) {
    this.$modalBibliographyDetailSet.open({
      bibliographySetId,
      isBibliographySelectProcess: false,
      tabType,
      onToggleReal: (
        bibliographyId: number,
        tabType: BibliographyDetailRealTabType
      ) => {
        this.openModalBibliographyDetailReal(bibliographyId, tabType)
      }
    })
  }
  // ここまで資料照会

  @Emit('all-select')
  onClickAllSelect(): void {}

  @Emit('delete:reserve')
  onClickDeleteReserve(id: number): number {
    return id
  }

  @Emit('update:reserve-expiration')
  onClickUpdateReserveExpiration(index: number): number {
    return findIndex(this.items, {
      id: this.sortedItems[index].id
    })
  }

  @Emit('detail')
  onClickDetail(bibliographyId: number): number {
    return bibliographyId
  }

  @Emit('specify-collection-id')
  onClickSpecifyCollectionIdLink(
    reserveType: ReserveType,
    reserveSetGroupId: number,
    bibliographyId: number
  ): any {
    return {
      reserveType,
      reserveSetGroupId,
      bibliographyId
    }
  }
}
